export default "/Gyeongbokgung.glb";